export const formats = {
  date: {
    base: {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    },
  },
} as const
